import { createRequestInstance } from '../'

import type { Image } from 'types'

const PROGRAMMING_URL = import.meta.env.VITE_PROGRAMMING_URL || ''
const PLAYBOOK_CONTENT_ID = import.meta.env.VITE_PLAYBOOK_CONTENT_ID || ''
const CONTENT_KIT_CONTENT_ID = import.meta.env.VITE_CONTENT_KIT_CONTENT_ID || ''

const request = createRequestInstance({
  baseURL: PROGRAMMING_URL,
})

export enum SubscriptionType {
  beta = 'beta',
  standard = 'standard',
}

export enum SubscriptionStatus {
  active = 'active',
  inactive = 'inactive',
}

export enum SubscriptionPackageType {
  ATK = 'ATK',
  ATK_STARTER = 'ATK-STARTER',
  CAP = 'CAP',
}

export type FetchSubscriptionResponse = Subscription[]

export type Subscription = {
  expiryDate: string
  activationDate: string
  subscriptionCancelDate?: string | null
  requirementsMet?: boolean
  status: SubscriptionStatus
  type: SubscriptionType
  package: {
    name: SubscriptionPackageType
  }
  subscriberGroupId: number
}

export async function fetchSubscriptions(groupId: number) {
  const response = await request.get<FetchSubscriptionResponse>(
    'subscriptions',
    {
      params: {
        subscriber_group_id: groupId,
        include_inactive: true,
      },
    },
  )

  return response.data
}

async function fetchContent<T>(id: string) {
  const response = await request.get<T>(`/content/${id}`)

  return response.data
}

export async function fetchProgrammingContent<T>(path: string) {
  const response = await request.get<{
    tiles: [
      {
        acf: T
      },
    ]
  }>(`/content?urn=content_api://${path}`)

  return response.data.tiles[0].acf as T
}

type FetchPlaybookContentResponse = {
  tiles: [
    {
      acf: {
        headlineText: string
        subheadline: string
        bodyText: string
        imageGallery: { image: Image }[]
        pdfLinks: {
          contentId?: string
          linkText: string
          title: string
          pdfUrl: string
        }[]
      }
    },
  ]
}

export async function fetchPlaybookContent() {
  const data = await fetchContent<FetchPlaybookContentResponse>(
    PLAYBOOK_CONTENT_ID,
  )
  return data.tiles[0].acf
}

type FetchContentKitContentResponse = {
  tiles: [
    {
      acf: {
        headlineText: string
        subheadline: string
        bodyText: string
        imageGallery: { image: Image }[]
        contentHeadlineText: string
        contentLanguages: {
          contentLinks: {
            contentId: string
            linkUrl: string
            linkText: string
            title: string
          }[]
          language: string
        }[]
      }
    },
  ]
}

export async function fetchContentKitContent() {
  const data = await fetchContent<FetchContentKitContentResponse>(
    CONTENT_KIT_CONTENT_ID,
  )
  return data.tiles[0].acf
}

export async function fetchPDF(id: string) {
  const response = await request.get(`/content/${id}`, {
    responseType: 'blob',
  })

  return response.request.response
}
